import React from "react"
import { Skeleton } from "@material-ui/lab"
import {
	Grid,
	Divider as MuiDivider
} from "@material-ui/core"
import { colors } from "@/styles/colors"

const TemplatePageSkeleton = () => {
	return (
		<>
			{Array.from(new Array(3)).map((_, index) => (
				<Grid item style={{ width: 330 }} key={index}>
					<Grid container spacing={1} style={{ padding: 16, border: `1px solid ${colors.gray[100]}`, borderRadius: "8px" }}>
						<Grid item xs={12}>
							<Grid container justifyContent="space-between" alignItems="center">
								<Grid item>
									<Skeleton variant="rect" width={190} height={22} style={{ borderRadius: 4 }} />
								</Grid>
								<Grid item>
									<Skeleton variant="rect" width={24} height={22} style={{ borderRadius: 4 }} />
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Grid container direction="row" style={{ gap: 8 }}>
								<Grid item>
									<Skeleton variant="rect" width={110} height={32} style={{ borderRadius: 16 }} />
								</Grid>
								<Grid item>
									<Skeleton variant="rect" width={110} height={32} style={{ borderRadius: 16 }} />
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Skeleton variant="rect" width="100%" height={324} style={{ borderRadius: 8 }} />
						</Grid>
						<Grid item xs={12}>
							<MuiDivider />
						</Grid>
						<Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
							<Skeleton variant="rect" width={90} height={30} style={{ borderRadius: 16 }} />
						</Grid>
					</Grid>
				</Grid>
			))}
		</>
	)
}

export default TemplatePageSkeleton
